import { SvgIcon } from "@mui/material"

const BackIcon = (props: any) => {
  return (
    <SvgIcon {...props}>
      <line x1="21.7" y1="12" x2="2.3" y2="12" stroke="#FFFFFF" strokeWidth="1.0564" />
	    <polyline points="8.9,18.5 2.3,12 8.9,5.5" fill="none" stroke="#FFFFFF" />
    </SvgIcon>
  )
}

export default BackIcon;
